import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { Quote, Vehicle } from '@sm360/widget-commons-vehicle';

const { VehicleTitleSpecs } = Vehicle;

const VehicleTitle = ({ quote, vehicle, deleteQuote }) => {
    const isInApprovalStatus = quote.isQuoteInApproval();
    const isQuoteInPending = quote.isQuoteInPending();
    const pendingTransKey = isInApprovalStatus ? 'GARAGE.PENDING_APPROVAL' : 'GARAGE.PENDING_TRANSACTIONS';
    const isAvailable = isQuoteInPending || vehicle.isAvailable();
    const props = {
        vehicle,
        url: isAvailable ? quote.getVDPUrl() : '',
        className: 'vehicle-title-header sr-text is-bold',
        isAvailable,
    };

    const titleBody = [<VehicleTitleSpecs {...props} />];

    if (!isQuoteInPending && !isInApprovalStatus) {
        const deleteButton = (
            <button className="vehicle-delete" onClick={() => deleteQuote(quote)}>
                <p className="vehicle-delete__label">{LocaleService.t('GARAGE.REMOVE_VEHICLE')}</p>
                <icon className="icon-trash-can" />
            </button>
        );
        titleBody.push(deleteButton);
    } else {
        titleBody.push(<p className="vehicle-transaction">{LocaleService.t(pendingTransKey)}</p>);
    }

    return <div className="vehicle-title__wrapper">{titleBody}</div>;
};

VehicleTitle.propTypes = {
    deleteQuote: PropTypes.func.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModel).isRequired,
};

VehicleTitle.displayName = 'VehicleTitle';

export default VehicleTitle;
